"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bridge = exports.isWindowWithBridge = void 0;
var isWindowWithBridge = function (input) {
    return input.Bridge != null &&
        typeof input.Bridge.setMasterToken === 'function' &&
        typeof input.Bridge.setSessionToken === 'function' &&
        typeof input.Bridge.getMasterToken === 'function' &&
        typeof input.Bridge.getSessionToken === 'function';
};
exports.isWindowWithBridge = isWindowWithBridge;
exports.bridge = typeof window !== 'undefined' && (0, exports.isWindowWithBridge)(window) ? window.Bridge : undefined;
//# sourceMappingURL=index.js.map